import { render, staticRenderFns } from "./WizzardProgress.vue?vue&type=template&id=4506d686"
import script from "./WizzardProgress.vue?vue&type=script&lang=js"
export * from "./WizzardProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports